"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Tile = _interopRequireDefault(require("ol/Tile"));

var _TileImage = _interopRequireDefault(require("ol/source/TileImage"));

var _Tile2 = _interopRequireDefault(require("ol/layer/Tile"));

var _TileState = _interopRequireDefault(require("ol/TileState"));

var _createLayer = _interopRequireDefault(require("./createLayer"));

var _tilegrid = require("ol/tilegrid");

var _propTypes = require("prop-types");

function inherits(childCtor, parentCtor) {
  childCtor.prototype = Object.create(parentCtor.prototype); // eslint-disable-line no-param-reassign

  childCtor.prototype.constructor = childCtor; // eslint-disable-line no-param-reassign
}

var JSONLayer = (0, _createLayer["default"])({
  displayName: 'JSONLayer',
  propTypes: {
    getTileData: _propTypes.func,
    renderTile: _propTypes.func,
    url: _propTypes.string
  },
  componentDidMount: function componentDidMount() {
    var renderTile = this.props.renderTile;
    var loadFunc = this.props.getTileData;

    var JsonTile = function JsonTile(tileCoord, state, src, crossOrigin, tileLoadFunc) {
      _Tile["default"].call(this, tileCoord, state, src, crossOrigin, tileLoadFunc);

      this.src = src;
      this.loadFunc = loadFunc;
    };

    inherits(JsonTile, _Tile["default"]);

    JsonTile.prototype.load = function () {
      if (this.loadFunc) {
        this.data = this.loadFunc(this);
        this.state = _TileState["default"].LOADED;
        this.changed();
        return;
      } else if (this.src) {
        this.state = _TileState["default"].LOADING;
        var tile = this;
        fetch(this.src).then(function (response) {
          return response.json();
        }).then(function (data) {
          tile.state = _TileState["default"].LOADED;
          tile.data = data;
          tile.changed();
        })["catch"](function (err) {
          console.warn(err); // eslint-disable-line no-console

          tile.state = _TileState["default"].ERROR;
          tile.changed();
        });
      } else {
        throw new Error('Neither source or data function are available');
      }
    };

    JsonTile.prototype.getImage = function () {
      if (!this._canvas) {
        this._canvas = document.createElement('canvas');
        this._canvas.width = 256;
        this._canvas.height = 256;
      }

      renderTile(this.data, this._canvas, this);
      return this._canvas;
    };

    var JsonSource = function JsonSource(opt_options) {
      var options = opt_options || {};
      var url = options.url !== undefined ? options.url : 'no';
      var tileGrid = (0, _tilegrid.createXYZ)({});

      _TileImage["default"].call(this, {
        tileClass: JsonTile,
        tileGrid: tileGrid,
        tileUrlFunction: options.tileUrlFunction,
        url: url,
        wrapX: true
      });
    };

    inherits(JsonSource, _TileImage["default"]);
    this.layer = new _Tile2["default"]({
      source: new JsonSource({
        url: this.props.url,
        tileUrlFunction: null
      })
    });
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    if (this.props.url !== prevProps.url) {
      this.layer.getSource().setUrl(this.props.url);
    }
  }
});
var _default = JSONLayer;
exports["default"] = _default;